/* istanbul ignore file */
import { makeConfig, request } from '@codegrade/api-core';
import { promise } from '@codegrade/utils';
import { about } from './_services/about';
import { assignment } from './_services/assignment';
import { autoTest } from './_services/autoTest';
import { comment } from './_services/comment';
import { course } from './_services/course';
import { coursePrice } from './_services/coursePrice';
import { file } from './_services/file';
import { gitProvider } from './_services/gitProvider';
import { group } from './_services/group';
import { groupSet } from './_services/groupSet';
import { loginLink } from './_services/loginLink';
import { lti } from './_services/lti';
import { notification } from './_services/notification';
import { oauthProvider } from './_services/oauthProvider';
import { oauthToken } from './_services/oauthToken';
import { permission } from './_services/permission';
import { plagiarism } from './_services/plagiarism';
import { role } from './_services/role';
import { saml } from './_services/saml';
import { section } from './_services/section';
import { siteSettings } from './_services/siteSettings';
import { snippet } from './_services/snippet';
import { ssoProvider } from './_services/ssoProvider';
import { submission } from './_services/submission';
import { taskResult } from './_services/taskResult';
import { tenant } from './_services/tenant';
import { transaction } from './_services/transaction';
import { user } from './_services/user';
import { userSetting } from './_services/userSetting';
import { webhook } from './_services/webhook';
export { ApiResult, ApiResultError, WarningHeader } from '@codegrade/api-core';
export { _BasePrice } from '@codegrade/api-models';
export { _SamlUiLogoInfo } from '@codegrade/api-models';
export { _SubmissionRubricItemDataParser } from '@codegrade/api-models';
export { About } from '@codegrade/api-models';
export { AbstractRole } from '@codegrade/api-models';
export { AccessTokenModalWarningTimeSetting } from '@codegrade/api-models';
export { AccessTokenToastWarningTimeSetting } from '@codegrade/api-models';
export { AddUsersSectionData } from '@codegrade/api-models';
export { AiAssistantEnabledSetting } from '@codegrade/api-models';
export { AllAutoTestResults } from '@codegrade/api-models';
export { AllSiteSettings } from '@codegrade/api-models';
export { AlwaysUpdatePiiWithLtiSetting } from '@codegrade/api-models';
export { AnalyticsEnabledSetting } from '@codegrade/api-models';
export { AnyAutoTestStepAsJSON } from '@codegrade/api-models';
export { AnyError } from '@codegrade/api-models';
export { AnyNonRedactedAutoTestStepAsJSON } from '@codegrade/api-models';
export { AnyRedactedAutoTestStepAsJSON } from '@codegrade/api-models';
export { APICodes } from '@codegrade/api-models';
export { Assignment } from '@codegrade/api-models';
export { AssignmentAnonymizationAlgo } from '@codegrade/api-models';
export { AssignmentDefaultGradingScalePointsSetting } from '@codegrade/api-models';
export { AssignmentDefaultGradingScaleSetting } from '@codegrade/api-models';
export { AssignmentDescriptionEnabledSetting } from '@codegrade/api-models';
export { AssignmentDescriptionOnTeachersSubmissionsPageSetting } from '@codegrade/api-models';
export { AssignmentDoneType } from '@codegrade/api-models';
export { AssignmentExportColumn } from '@codegrade/api-models';
export { AssignmentFeedback } from '@codegrade/api-models';
export { AssignmentGrader } from '@codegrade/api-models';
export { AssignmentGradingScalePointsEnabledSetting } from '@codegrade/api-models';
export { AssignmentKind } from '@codegrade/api-models';
export { AssignmentLoginLink } from '@codegrade/api-models';
export { AssignmentMaxPointsEnabledSetting } from '@codegrade/api-models';
export { AssignmentPeerFeedbackConnection } from '@codegrade/api-models';
export { AssignmentPeerFeedbackSettings } from '@codegrade/api-models';
export { AssignmentPercentageDecimalsSetting } from '@codegrade/api-models';
export { AssignmentPercentageGradingSettings } from '@codegrade/api-models';
export { AssignmentPointDecimalsSetting } from '@codegrade/api-models';
export { AssignmentPointsGradingSettings } from '@codegrade/api-models';
export { AssignmentSectionTimeframe } from '@codegrade/api-models';
export { AssignmentStateEnum } from '@codegrade/api-models';
export { AssignmentSubmissionMode } from '@codegrade/api-models';
export { AssignmentTemplate } from '@codegrade/api-models';
export { AssignmentTimeframes } from '@codegrade/api-models';
export { AtImageCachingEnabledSetting } from '@codegrade/api-models';
export { AutomaticLti1p3AssignmentImportSetting } from '@codegrade/api-models';
export { AutomaticLtiRoleEnabledSetting } from '@codegrade/api-models';
export { AutoTest } from '@codegrade/api-models';
export { AutoTestCapturePointsMessageSetting } from '@codegrade/api-models';
export { AutoTestCheckpointMessageSetting } from '@codegrade/api-models';
export { AutoTestCodeQualityMessageSetting } from '@codegrade/api-models';
export { AutoTestEnabledSetting } from '@codegrade/api-models';
export { AutoTestFixture } from '@codegrade/api-models';
export { AutoTestGlobalSetupOutput } from '@codegrade/api-models';
export { AutoTestGlobalSetupScript } from '@codegrade/api-models';
export { AutoTestHeartbeatIntervalSetting } from '@codegrade/api-models';
export { AutoTestHeartbeatMaxMissedSetting } from '@codegrade/api-models';
export { AutoTestIoTestMessageSetting } from '@codegrade/api-models';
export { AutoTestIoTestSubMessageSetting } from '@codegrade/api-models';
export { AutoTestMaxConcurrentBatchRunsSetting } from '@codegrade/api-models';
export { AutoTestMaxGlobalSetupTimeSetting } from '@codegrade/api-models';
export { AutoTestMaxJobsPerRunnerSetting } from '@codegrade/api-models';
export { AutoTestMaxPerStudentSetupTimeSetting } from '@codegrade/api-models';
export { AutoTestMaxResultNotStartedSetting } from '@codegrade/api-models';
export { AutoTestMaxTimeCommandSetting } from '@codegrade/api-models';
export { AutoTestMaxUnitTestMetadataLengthSetting } from '@codegrade/api-models';
export { AutoTestQualityComment } from '@codegrade/api-models';
export { AutoTestResult } from '@codegrade/api-models';
export { AutoTestResultState } from '@codegrade/api-models';
export { AutoTestResultWithExtraData } from '@codegrade/api-models';
export { AutoTestRun } from '@codegrade/api-models';
export { AutoTestRunner } from '@codegrade/api-models';
export { AutoTestRunnerState } from '@codegrade/api-models';
export { AutoTestRunProgramMessageSetting } from '@codegrade/api-models';
export { AutoTestSet } from '@codegrade/api-models';
export { AutoTestStepBase } from '@codegrade/api-models';
export { AutoTestStepBaseAsJSON } from '@codegrade/api-models';
export { AutoTestStepBaseInputAsJSON } from '@codegrade/api-models';
export { AutoTestStepLogBase } from '@codegrade/api-models';
export { AutoTestStepResult } from '@codegrade/api-models';
export { AutoTestStepResultState } from '@codegrade/api-models';
export { AutoTestStepValidationException } from '@codegrade/api-models';
export { AutoTestSuite } from '@codegrade/api-models';
export { AutoTestUnitTestMessageSetting } from '@codegrade/api-models';
export { BaseAbout } from '@codegrade/api-models';
export { BaseAutoTestQualityComment } from '@codegrade/api-models';
export { BaseCommentBase } from '@codegrade/api-models';
export { BaseCommentBaseWithExtendedReplies } from '@codegrade/api-models';
export { BaseCommentBaseWithNormalReplies } from '@codegrade/api-models';
export { BaseCommentReply } from '@codegrade/api-models';
export { BaseCourseCoupon } from '@codegrade/api-models';
export { BaseDirectory } from '@codegrade/api-models';
export { BaseError } from '@codegrade/api-models';
export { BaseFile } from '@codegrade/api-models';
export { BaseLMSCapabilities } from '@codegrade/api-models';
export { BaseLTI1p1Provider } from '@codegrade/api-models';
export { BaseLTI1p3Provider } from '@codegrade/api-models';
export { BaseLTIProvider } from '@codegrade/api-models';
export { BaseNotification } from '@codegrade/api-models';
export { BaseReleaseInfo } from '@codegrade/api-models';
export { BaseRubricItem } from '@codegrade/api-models';
export { BaseTenantCoupon } from '@codegrade/api-models';
export { BlackboardZipUploadEnabledSetting } from '@codegrade/api-models';
export { BulkEnrollCourseData } from '@codegrade/api-models';
export { CanvasCourseIdCopyingEnabledSetting } from '@codegrade/api-models';
export { CGIgnoreVersion } from '@codegrade/api-models';
export { ChangeUserRoleCourseData } from '@codegrade/api-models';
export { CheckPointsAsJSON } from '@codegrade/api-models';
export { CheckPointsData } from '@codegrade/api-models';
export { CheckPointsExtra } from '@codegrade/api-models';
export { CheckPointsInputAsJSON } from '@codegrade/api-models';
export { CloneResult } from '@codegrade/api-models';
export { CodeEditorOutputViewerTitleSetting } from '@codegrade/api-models';
export { CodeEditorStartOnAssignmentDescriptionSetting } from '@codegrade/api-models';
export { CodeQualityAsJSON } from '@codegrade/api-models';
export { CodeQualityBaseData } from '@codegrade/api-models';
export { CodeQualityData } from '@codegrade/api-models';
export { CodeQualityExtra } from '@codegrade/api-models';
export { CodeQualityInputAsJSON } from '@codegrade/api-models';
export { CodeQualityPenalties } from '@codegrade/api-models';
export { ColumnRange } from '@codegrade/api-models';
export { CommentBase } from '@codegrade/api-models';
export { CommentReply } from '@codegrade/api-models';
export { CommentReplyEdit } from '@codegrade/api-models';
export { CommentReplyType } from '@codegrade/api-models';
export { CommentType } from '@codegrade/api-models';
export { CommunityLibraryPublishingSetting } from '@codegrade/api-models';
export { CommunityLibrarySetting } from '@codegrade/api-models';
export { ConnectRepositoryGitProviderData } from '@codegrade/api-models';
export { CopyAutoTestData } from '@codegrade/api-models';
export { CopyRubricAssignmentData } from '@codegrade/api-models';
export { CouponDataParser } from '@codegrade/api-models';
export { CouponWithCode } from '@codegrade/api-models';
export { CouponWithoutCode } from '@codegrade/api-models';
export { Course } from '@codegrade/api-models';
export { CourseBulkEnrollResult } from '@codegrade/api-models';
export { CourseBulkRegisterEnabledSetting } from '@codegrade/api-models';
export { CourseCoupon } from '@codegrade/api-models';
export { CourseCouponUsage } from '@codegrade/api-models';
export { CourseGradebookEnabledSetting } from '@codegrade/api-models';
export { CourseGradebookRenderWarningSizeSetting } from '@codegrade/api-models';
export { CourseOfCoursePrice } from '@codegrade/api-models';
export { CourseOfTenantCouponUsage } from '@codegrade/api-models';
export { CoursePermission } from '@codegrade/api-models';
export { CoursePermMap } from '@codegrade/api-models';
export { CoursePrice } from '@codegrade/api-models';
export { CourseRegisterEnabledSetting } from '@codegrade/api-models';
export { CourseRegistrationLink } from '@codegrade/api-models';
export { CourseRole } from '@codegrade/api-models';
export { CourseRoleAsJSONWithPerms } from '@codegrade/api-models';
export { CourseSection } from '@codegrade/api-models';
export { CourseSectionDivision } from '@codegrade/api-models';
export { CourseSectionDivisionConnection } from '@codegrade/api-models';
export { CourseSectionDivisionUser } from '@codegrade/api-models';
export { CourseSnippet } from '@codegrade/api-models';
export { CourseState } from '@codegrade/api-models';
export { CourseStatisticsAsJSON } from '@codegrade/api-models';
export { CreateAssignmentCourseData } from '@codegrade/api-models';
export { CreateAutoTestData } from '@codegrade/api-models';
export { CreateCommentData } from '@codegrade/api-models';
export { CreateCommentReplyData } from '@codegrade/api-models';
export { CreateCourseData } from '@codegrade/api-models';
export { CreateDivisionSectionData } from '@codegrade/api-models';
export { CreateGroupGroupSetData } from '@codegrade/api-models';
export { CreateGroupSetCourseData } from '@codegrade/api-models';
export { CreateLTIData } from '@codegrade/api-models';
export { CreateOutputHtmlProxyAutoTestData } from '@codegrade/api-models';
export { CreateProxySubmissionData } from '@codegrade/api-models';
export { CreateRepositoryGitProviderData } from '@codegrade/api-models';
export { CreateRoleCourseData } from '@codegrade/api-models';
export { CreateSectionCourseData } from '@codegrade/api-models';
export { CreateSnippetCourseData } from '@codegrade/api-models';
export { CreateSnippetData } from '@codegrade/api-models';
export { CreateSSOProviderData } from '@codegrade/api-models';
export { CreateTenantData } from '@codegrade/api-models';
export { CsvLargeFileLimitSetting } from '@codegrade/api-models';
export { CsvTooManyErrorsLimitSetting } from '@codegrade/api-models';
export { Currency } from '@codegrade/api-models';
export { CustomOutputAsJSON } from '@codegrade/api-models';
export { CustomOutputData } from '@codegrade/api-models';
export { CustomOutputExtra } from '@codegrade/api-models';
export { CustomOutputInputAsJSON } from '@codegrade/api-models';
export { CustomOutputLog } from '@codegrade/api-models';
export { CustomOutputLogBase } from '@codegrade/api-models';
export { DefaultCourseTaRoleSetting } from '@codegrade/api-models';
export { DefaultCourseTeacherRoleSetting } from '@codegrade/api-models';
export { DefaultSubmissionPageTabSetting } from '@codegrade/api-models';
export { DeletedCommentReply } from '@codegrade/api-models';
export { DeletionType } from '@codegrade/api-models';
export { DirectoryWithChildren } from '@codegrade/api-models';
export { DisabledSettingException } from '@codegrade/api-models';
export { DisplayGradesEnabledSetting } from '@codegrade/api-models';
export { EditorEnabledForTeachersSetting } from '@codegrade/api-models';
export { EditorEnabledSetting } from '@codegrade/api-models';
export { EmailNotificationTypes } from '@codegrade/api-models';
export { EmailStudentsEnabledSetting } from '@codegrade/api-models';
export { EmailUsersCourseData } from '@codegrade/api-models';
export { ExamLoginMaxLengthSetting } from '@codegrade/api-models';
export { ExportAssignmentCSVData } from '@codegrade/api-models';
export { ExportAssignmentData } from '@codegrade/api-models';
export { ExportAssignmentFilesData } from '@codegrade/api-models';
export { ExtendedAutoTestResult } from '@codegrade/api-models';
export { ExtendedAutoTestRun } from '@codegrade/api-models';
export { ExtendedCourse } from '@codegrade/api-models';
export { ExtendedCourseRegistrationLink } from '@codegrade/api-models';
export { ExtendedCourseSection } from '@codegrade/api-models';
export { ExtendedGroup } from '@codegrade/api-models';
export { ExtendedJob } from '@codegrade/api-models';
export { ExtendedNonDeletedCommentReply } from '@codegrade/api-models';
export { ExtendedTenant } from '@codegrade/api-models';
export { ExtendedTransaction } from '@codegrade/api-models';
export { ExtendedUser } from '@codegrade/api-models';
export { ExtendedWork } from '@codegrade/api-models';
export { ExtractFileTreeDirectory } from '@codegrade/api-models';
export { ExtractFileTreeFile } from '@codegrade/api-models';
export { FailedToSendEmailException } from '@codegrade/api-models';
export { FeedbackBase } from '@codegrade/api-models';
export { FeedbackThreadsInitiallyCollapsedSetting } from '@codegrade/api-models';
export { FeedbackWithoutReplies } from '@codegrade/api-models';
export { FeedbackWithReplies } from '@codegrade/api-models';
export { FileDeletion } from '@codegrade/api-models';
export { FileRule } from '@codegrade/api-models';
export { FileRuleInputData } from '@codegrade/api-models';
export { FileTree } from '@codegrade/api-models';
export { FileType } from '@codegrade/api-models';
export { FinalizedLTI1p1Provider } from '@codegrade/api-models';
export { FinalizedLTI1p3Provider } from '@codegrade/api-models';
export { FirstDayOfWeekFromLocaleSetting } from '@codegrade/api-models';
export { FirstPhaseLTILaunchException } from '@codegrade/api-models';
export { FixedAvailability } from '@codegrade/api-models';
export { FixedGradeAvailability } from '@codegrade/api-models';
export { FixtureLike } from '@codegrade/api-models';
export { Fraction } from '@codegrade/api-models';
export { FrontendSiteSettings } from '@codegrade/api-models';
export { GeneralFeedbackCommentBase } from '@codegrade/api-models';
export { GeneralFeedbackCommentBaseWithExtendedReplies } from '@codegrade/api-models';
export { GeneralFeedbackExtra } from '@codegrade/api-models';
export { GithubTemplateRepoEnabledSetting } from '@codegrade/api-models';
export { GitRepositoriesPage } from '@codegrade/api-models';
export { GitRepositoryLike } from '@codegrade/api-models';
export { GitUserInfo } from '@codegrade/api-models';
export { GlobalPermission } from '@codegrade/api-models';
export { GlobalPermMap } from '@codegrade/api-models';
export { GradeHistory } from '@codegrade/api-models';
export { GradeOrigin } from '@codegrade/api-models';
export { GradingNotificationsEnabledSetting } from '@codegrade/api-models';
export { Group } from '@codegrade/api-models';
export { GroupNotReadyForSubmissionException } from '@codegrade/api-models';
export { GroupsEnabledSetting } from '@codegrade/api-models';
export { GroupSet } from '@codegrade/api-models';
export { HasUnreadNotifcationJSON } from '@codegrade/api-models';
export { HealthInformation } from '@codegrade/api-models';
export { HideCodeEditorFiletreeControlsWithOnlyQuizStepsSetting } from '@codegrade/api-models';
export { HideCodeEditorOutputViewerWithOnlyQuizStepsSetting } from '@codegrade/api-models';
export { HideEmptyRubricRowDescriptionSetting } from '@codegrade/api-models';
export { HideNoDeadlineEnabledSetting } from '@codegrade/api-models';
export { HubspotSyncingEnabledSetting } from '@codegrade/api-models';
export { IgnoredFilesException } from '@codegrade/api-models';
export { IgnoreHandling } from '@codegrade/api-models';
export { ImportIntoAssignmentData } from '@codegrade/api-models';
export { ImportIntoCourseData } from '@codegrade/api-models';
export { IncrementalRubricSubmissionEnabledSetting } from '@codegrade/api-models';
export { InlineFeedbackCommentBase } from '@codegrade/api-models';
export { InlineFeedbackCommentBaseWithExtendedReplies } from '@codegrade/api-models';
export { InlineFeedbackExtra } from '@codegrade/api-models';
export { InlineFeedbackOnQuizzesEnabledSetting } from '@codegrade/api-models';
export { InlineRubricViewerEnabledSetting } from '@codegrade/api-models';
export { InvalidGroupException } from '@codegrade/api-models';
export { InvalidIOCasesException } from '@codegrade/api-models';
export { InvalidOptionsException } from '@codegrade/api-models';
export { IOTestAsJSON } from '@codegrade/api-models';
export { IOTestBaseData } from '@codegrade/api-models';
export { IOTestData } from '@codegrade/api-models';
export { IOTestExtra } from '@codegrade/api-models';
export { IOTestInputAsJSON } from '@codegrade/api-models';
export { IOTestInputCase } from '@codegrade/api-models';
export { IOTestLog } from '@codegrade/api-models';
export { IOTestOption } from '@codegrade/api-models';
export { IOTestStepLog } from '@codegrade/api-models';
export { IOTestStepLogBase } from '@codegrade/api-models';
export { IsAdminPermissionEnabledSetting } from '@codegrade/api-models';
export { IsPearsonSetting } from '@codegrade/api-models';
export { Job } from '@codegrade/api-models';
export { JsonCreateAutoTest } from '@codegrade/api-models';
export { JsonCreateTenant } from '@codegrade/api-models';
export { JsonPatchAutoTest } from '@codegrade/api-models';
export { JsonPatchSubmitTypesAssignment } from '@codegrade/api-models';
export { JunitTestAsJSON } from '@codegrade/api-models';
export { JunitTestBaseData } from '@codegrade/api-models';
export { JunitTestData } from '@codegrade/api-models';
export { JunitTestExtra } from '@codegrade/api-models';
export { JunitTestInputAsJSON } from '@codegrade/api-models';
export { JunitTestLog } from '@codegrade/api-models';
export { JunitTestLogBase } from '@codegrade/api-models';
export { JwtAccessTokenExpiresSetting } from '@codegrade/api-models';
export { LegacyFeatures } from '@codegrade/api-models';
export { LineRange } from '@codegrade/api-models';
export { LintersEnabledSetting } from '@codegrade/api-models';
export { LMSCapabilities } from '@codegrade/api-models';
export { LoginTokenBeforeTimeSetting } from '@codegrade/api-models';
export { LoginUserData } from '@codegrade/api-models';
export { LogoutResponse } from '@codegrade/api-models';
export { LogoutUserData } from '@codegrade/api-models';
export { LTI1p1Provider } from '@codegrade/api-models';
export { LTI1p1ProviderData } from '@codegrade/api-models';
export { Lti1p3NonceAndStateValidationEnabledSetting } from '@codegrade/api-models';
export { Lti1p3ParseMostPrivilegedRoleSetting } from '@codegrade/api-models';
export { Lti1p3PreventNonceReuseEnabledSetting } from '@codegrade/api-models';
export { LTI1p3Provider } from '@codegrade/api-models';
export { LTI1p3ProviderData } from '@codegrade/api-models';
export { LTI1p3ProviderPresentationAsJSON } from '@codegrade/api-models';
export { Lti1p3SystemRoleFromContextRoleSetting } from '@codegrade/api-models';
export { LtiEnabledSetting } from '@codegrade/api-models';
export { LtiFirstLaunchContentIdEnabledSetting } from '@codegrade/api-models';
export { LtiLaunchDataLoggingSetting } from '@codegrade/api-models';
export { LtiLockDateCopyingEnabledSetting } from '@codegrade/api-models';
export { LTIProviderBase } from '@codegrade/api-models';
export { LtiUnsetDeadlineLockDateEnabledSetting } from '@codegrade/api-models';
export { MaxDocumentUpdateSizeSetting } from '@codegrade/api-models';
export { MaxDynamoFileSizeSetting } from '@codegrade/api-models';
export { MaxDynamoSubmissionSizeSetting } from '@codegrade/api-models';
export { MaxFileSizeSetting } from '@codegrade/api-models';
export { MaxLargeUploadSizeSetting } from '@codegrade/api-models';
export { MaxLinesSetting } from '@codegrade/api-models';
export { MaxNormalUploadSizeSetting } from '@codegrade/api-models';
export { MaxNumberOfFilesSetting } from '@codegrade/api-models';
export { MaxPlagiarismMatchesSetting } from '@codegrade/api-models';
export { MaxUserSettingAmountSetting } from '@codegrade/api-models';
export { MinPasswordScoreSetting } from '@codegrade/api-models';
export { MirrorFileResult } from '@codegrade/api-models';
export { MissingCookieError } from '@codegrade/api-models';
export { MissingFile } from '@codegrade/api-models';
export { NameAndEmailFromNrpsOnlySetting } from '@codegrade/api-models';
export { NewAutoTestAllowedInitialBuildIdsSetting } from '@codegrade/api-models';
export { NewAutoTestBuildMaxCommandTimeSetting } from '@codegrade/api-models';
export { NewAutoTestBuildOutputLimitSetting } from '@codegrade/api-models';
export { NewAutoTestCopyingEnabledSetting } from '@codegrade/api-models';
export { NewAutoTestCurrentInitialBuildIdsSetting } from '@codegrade/api-models';
export { NewAutoTestDiffViewerEnabledSetting } from '@codegrade/api-models';
export { NewAutoTestEnabledSetting } from '@codegrade/api-models';
export { NewAutoTestInitialBuildIdSetting } from '@codegrade/api-models';
export { NewAutoTestMaxDynamodbSizeSetting } from '@codegrade/api-models';
export { NewAutoTestMaxFileSizeSetting } from '@codegrade/api-models';
export { NewAutoTestMaxOutputFilesSizeSetting } from '@codegrade/api-models';
export { NewAutoTestMaxStorageSizeSetting } from '@codegrade/api-models';
export { NewAutoTestOldSubmissionAgeSetting } from '@codegrade/api-models';
export { NewAutoTestTestMaxCommandTimeSetting } from '@codegrade/api-models';
export { NewAutoTestTestOutputLimitSetting } from '@codegrade/api-models';
export { NewAutoTestUncollapsingStepOutputDelaySetting } from '@codegrade/api-models';
export { NonDeletedCommentReply } from '@codegrade/api-models';
export { NonFinalizedLTI1p1Provider } from '@codegrade/api-models';
export { NonFinalizedLTI1p3Provider } from '@codegrade/api-models';
export { NonPresentPreference } from '@codegrade/api-models';
export { NoPermissions } from '@codegrade/api-models';
export { Notification } from '@codegrade/api-models';
export { NotificationCommentReplyNotificationAsJSON } from '@codegrade/api-models';
export { NotificationGeneralFeedbackReplyNotificationAsJSON } from '@codegrade/api-models';
export { NotificationPollTimeSetting } from '@codegrade/api-models';
export { NotificationReasons } from '@codegrade/api-models';
export { NotificationSetting } from '@codegrade/api-models';
export { NotificationSettingOption } from '@codegrade/api-models';
export { NotificationsJSON } from '@codegrade/api-models';
export { OAuthProvider } from '@codegrade/api-models';
export { OAuthToken } from '@codegrade/api-models';
export { Option } from '@codegrade/api-models';
export { OptionsInputData } from '@codegrade/api-models';
export { OutputViewerAnimationLimitLinesCountSetting } from '@codegrade/api-models';
export { OutputViewerAutoExpandFailedStepsSetting } from '@codegrade/api-models';
export { ParseAPIException } from '@codegrade/api-models';
export { Patch1P1ProviderLTIData } from '@codegrade/api-models';
export { Patch1P3ProviderLTIData } from '@codegrade/api-models';
export { PatchAllNotificationData } from '@codegrade/api-models';
export { PatchAssignmentData } from '@codegrade/api-models';
export { PatchAutoTestData } from '@codegrade/api-models';
export { PatchCommentReplyData } from '@codegrade/api-models';
export { PatchCourseData } from '@codegrade/api-models';
export { PatchGraderSubmissionData } from '@codegrade/api-models';
export { PatchNotificationData } from '@codegrade/api-models';
export { PatchNotificationSettingUserSettingData } from '@codegrade/api-models';
export { PatchProviderLTIData } from '@codegrade/api-models';
export { PatchRoleCourseData } from '@codegrade/api-models';
export { PatchRoleData } from '@codegrade/api-models';
export { PatchRoleTenantData } from '@codegrade/api-models';
export { PatchRubricCategoryTypeAssignmentData } from '@codegrade/api-models';
export { PatchRubricResultSubmissionData } from '@codegrade/api-models';
export { PatchSectionData } from '@codegrade/api-models';
export { PatchSettingsTenantData } from '@codegrade/api-models';
export { PatchSiteSettingsData } from '@codegrade/api-models';
export { PatchSnippetCourseData } from '@codegrade/api-models';
export { PatchSnippetData } from '@codegrade/api-models';
export { PatchSubmissionData } from '@codegrade/api-models';
export { PatchSubmitTypesAssignmentData } from '@codegrade/api-models';
export { PatchTenantData } from '@codegrade/api-models';
export { PatchUiPreferenceUserSettingData } from '@codegrade/api-models';
export { PatchUserData } from '@codegrade/api-models';
export { PayWithCouponCoursePriceData } from '@codegrade/api-models';
export { PearsonTemplatesSetting } from '@codegrade/api-models';
export { PearsonTryOutCodingQuestionEnabledSetting } from '@codegrade/api-models';
export { PeerFeedbackEnabledSetting } from '@codegrade/api-models';
export { PermissionException } from '@codegrade/api-models';
export { PlagiarismBulkExportEnabledSetting } from '@codegrade/api-models';
export { PlagiarismBulkExportMaxCasesSetting } from '@codegrade/api-models';
export { PlagiarismCase } from '@codegrade/api-models';
export { PlagiarismPdfExportEnabledSetting } from '@codegrade/api-models';
export { PlagiarismRun } from '@codegrade/api-models';
export { PlagiarismRunPlagiarismAssignmentAsJSON } from '@codegrade/api-models';
export { PlagiarismRunPlagiarismCourseAsJSON } from '@codegrade/api-models';
export { PlagiarismState } from '@codegrade/api-models';
export { PostOAuthTokenData } from '@codegrade/api-models';
export { PresentPreference } from '@codegrade/api-models';
export { Proxy } from '@codegrade/api-models';
export { PutDescriptionAssignmentData } from '@codegrade/api-models';
export { PutEnrollLinkCourseData } from '@codegrade/api-models';
export { PutPriceCourseData } from '@codegrade/api-models';
export { PutPriceTenantData } from '@codegrade/api-models';
export { PutRubricAssignmentData } from '@codegrade/api-models';
export { QualityCommentSeverity } from '@codegrade/api-models';
export { QualityCommentsInCodeEditorSetting } from '@codegrade/api-models';
export { QualityTestLog } from '@codegrade/api-models';
export { QualityTestLogBase } from '@codegrade/api-models';
export { QuizSingleQuestionModeHideRunButtonEnabledSetting } from '@codegrade/api-models';
export { RegisterEnabledSetting } from '@codegrade/api-models';
export { RegisterUserData } from '@codegrade/api-models';
export { RegisterUserWithLinkCourseData } from '@codegrade/api-models';
export { ReleaseInfo } from '@codegrade/api-models';
export { ReleaseMessageMaxTimeSetting } from '@codegrade/api-models';
export { RemovedPermissions } from '@codegrade/api-models';
export { RenameGroupGroupData } from '@codegrade/api-models';
export { RenderHtmlEnabledSetting } from '@codegrade/api-models';
export { RepositoryConnectionLimitReachedException } from '@codegrade/api-models';
export { ResetTokenTimeSetting } from '@codegrade/api-models';
export { ResultDataGetAutoTestGet } from '@codegrade/api-models';
export { ResultDataGetTaskResultGetAll } from '@codegrade/api-models';
export { ResultDataPostLoginLinkLogin } from '@codegrade/api-models';
export { ResultDataPostSectionCreateDivision } from '@codegrade/api-models';
export { ResultDataPostUserLogin } from '@codegrade/api-models';
export { ResultDataPostUserRegister } from '@codegrade/api-models';
export { RetryGroupSubmissionGradePassbackEnabledSetting } from '@codegrade/api-models';
export { RoleAsJSONWithPerms } from '@codegrade/api-models';
export { RootFileTreesJSON } from '@codegrade/api-models';
export { RubricDescriptionType } from '@codegrade/api-models';
export { RubricEnabledForTeacherOnSubmissionsPageSetting } from '@codegrade/api-models';
export { RubricItem } from '@codegrade/api-models';
export { RubricItemInputAsJSON } from '@codegrade/api-models';
export { RubricLockReason } from '@codegrade/api-models';
export { RubricRowBase } from '@codegrade/api-models';
export { RubricRowBaseInputAsJSON } from '@codegrade/api-models';
export { RubricRowBaseInputBaseAsJSON } from '@codegrade/api-models';
export { RubricsEnabledSetting } from '@codegrade/api-models';
export { RuleType } from '@codegrade/api-models';
export { RunProgramAsJSON } from '@codegrade/api-models';
export { RunProgramData } from '@codegrade/api-models';
export { RunProgramExtra } from '@codegrade/api-models';
export { RunProgramInputAsJSON } from '@codegrade/api-models';
export { RunProgramLog } from '@codegrade/api-models';
export { Saml2ProviderJSON } from '@codegrade/api-models';
export { SamlUiInfo } from '@codegrade/api-models';
export { SectionsInSubmissionListEnabledSetting } from '@codegrade/api-models';
export { SendRegistrationEmailSetting } from '@codegrade/api-models';
export { ServerTimeCorrectionEnabledSetting } from '@codegrade/api-models';
export { ServerTimeDiffToleranceSetting } from '@codegrade/api-models';
export { ServerTimeSyncIntervalSetting } from '@codegrade/api-models';
export { SessionRestrictionContext } from '@codegrade/api-models';
export { SessionRestrictionData } from '@codegrade/api-models';
export { SettingTokenTimeSetting } from '@codegrade/api-models';
export { SetupOAuthResult } from '@codegrade/api-models';
export { SimpleSubmissionModeEnabledSetting } from '@codegrade/api-models';
export { SimpleSubmissionNavigateToLatestEditorSessionSetting } from '@codegrade/api-models';
export { SiteEmailSetting } from '@codegrade/api-models';
export { SiteSettingInput } from '@codegrade/api-models';
export { Snippet } from '@codegrade/api-models';
export { SsoInferGlobalStaffRoleSetting } from '@codegrade/api-models';
export { SsoUsernameDecollisionEnabledSetting } from '@codegrade/api-models';
export { StagedAssignmentImporterEnabledSetting } from '@codegrade/api-models';
export { StartedTransaction } from '@codegrade/api-models';
export { StartPaymentCoursePriceCloseTabData } from '@codegrade/api-models';
export { StartPaymentCoursePriceData } from '@codegrade/api-models';
export { StartPaymentCoursePriceRedirectData } from '@codegrade/api-models';
export { StudentPaymentEnabledSetting } from '@codegrade/api-models';
export { StudentPaymentMainOptionSetting } from '@codegrade/api-models';
export { StudentViewEnabledSetting } from '@codegrade/api-models';
export { SubmissionsPerPageEnabledSetting } from '@codegrade/api-models';
export { SubmissionValidatorInputData } from '@codegrade/api-models';
export { TaskResultState } from '@codegrade/api-models';
export { TaxBehavior } from '@codegrade/api-models';
export { Tenant } from '@codegrade/api-models';
export { TenantCoupon } from '@codegrade/api-models';
export { TenantCouponUsage } from '@codegrade/api-models';
export { TenantCouponWithCode } from '@codegrade/api-models';
export { TenantCouponWithoutCode } from '@codegrade/api-models';
export { TenantCourseStatistics } from '@codegrade/api-models';
export { TenantOfTenantPrice } from '@codegrade/api-models';
export { TenantPermissions } from '@codegrade/api-models';
export { TenantPrice } from '@codegrade/api-models';
export { TenantRoleAsJSONWithPerms } from '@codegrade/api-models';
export { TenantStatistics } from '@codegrade/api-models';
export { TestSubmissionCopyingOnImportEnabledSetting } from '@codegrade/api-models';
export { TimedAvailability } from '@codegrade/api-models';
export { TimeframeLike } from '@codegrade/api-models';
export { TokenRevokedException } from '@codegrade/api-models';
export { Transaction } from '@codegrade/api-models';
export { TransactionState } from '@codegrade/api-models';
export { UpdatePeerFeedbackSettingsAssignmentData } from '@codegrade/api-models';
export { UpdateSetAutoTestData } from '@codegrade/api-models';
export { UpdateSuiteAutoTestBaseData } from '@codegrade/api-models';
export { UpdateSuiteAutoTestData } from '@codegrade/api-models';
export { UpgradedLTIProviderException } from '@codegrade/api-models';
export { UploadSubmissionAssignmentData } from '@codegrade/api-models';
export { User } from '@codegrade/api-models';
export { UserCourse } from '@codegrade/api-models';
export { UserInfoWithRole } from '@codegrade/api-models';
export { UserInput } from '@codegrade/api-models';
export { UserLoginResponse } from '@codegrade/api-models';
export { UserWithoutGroup } from '@codegrade/api-models';
export { WeakPasswordException } from '@codegrade/api-models';
export { WeakPasswordFeedback } from '@codegrade/api-models';
export { WebhookBase } from '@codegrade/api-models';
export { WebhookConfigurationDisabledAsJSON } from '@codegrade/api-models';
export { WebhookConfigurationEnabledAsJSON } from '@codegrade/api-models';
export { Work } from '@codegrade/api-models';
export { WorkOrigin } from '@codegrade/api-models';
export { WorkRubricItem } from '@codegrade/api-models';
export { WorkRubricResultAsJSON } from '@codegrade/api-models';
export { WorkRubricResultPointsAsJSON } from '@codegrade/api-models';
function eitherAsyncifyService(service) {
    return Object.fromEntries(Object.entries(service).map(([key, value]) => [key, promise.eitherAsyncify(value)]));
}
export class CodeGradeApi {
    config;
    p;
    about;
    assignment;
    autoTest;
    comment;
    course;
    coursePrice;
    file;
    gitProvider;
    group;
    groupSet;
    loginLink;
    lti;
    notification;
    oauthProvider;
    oauthToken;
    permission;
    plagiarism;
    role;
    saml;
    section;
    siteSettings;
    snippet;
    ssoProvider;
    submission;
    taskResult;
    tenant;
    transaction;
    user;
    userSetting;
    webhook;
    constructor(partialConfig) {
        this.config = makeConfig(partialConfig);
        this.p = Object.freeze({
            about: about(this.config),
            assignment: assignment(this.config),
            autoTest: autoTest(this.config),
            comment: comment(this.config),
            course: course(this.config),
            coursePrice: coursePrice(this.config),
            file: file(this.config),
            gitProvider: gitProvider(this.config),
            group: group(this.config),
            groupSet: groupSet(this.config),
            loginLink: loginLink(this.config),
            lti: lti(this.config),
            notification: notification(this.config),
            oauthProvider: oauthProvider(this.config),
            oauthToken: oauthToken(this.config),
            permission: permission(this.config),
            plagiarism: plagiarism(this.config),
            role: role(this.config),
            saml: saml(this.config),
            section: section(this.config),
            siteSettings: siteSettings(this.config),
            snippet: snippet(this.config),
            ssoProvider: ssoProvider(this.config),
            submission: submission(this.config),
            taskResult: taskResult(this.config),
            tenant: tenant(this.config),
            transaction: transaction(this.config),
            user: user(this.config),
            userSetting: userSetting(this.config),
            webhook: webhook(this.config),
        });
        this.about = eitherAsyncifyService(this.p.about);
        this.assignment = eitherAsyncifyService(this.p.assignment);
        this.autoTest = eitherAsyncifyService(this.p.autoTest);
        this.comment = eitherAsyncifyService(this.p.comment);
        this.course = eitherAsyncifyService(this.p.course);
        this.coursePrice = eitherAsyncifyService(this.p.coursePrice);
        this.file = eitherAsyncifyService(this.p.file);
        this.gitProvider = eitherAsyncifyService(this.p.gitProvider);
        this.group = eitherAsyncifyService(this.p.group);
        this.groupSet = eitherAsyncifyService(this.p.groupSet);
        this.loginLink = eitherAsyncifyService(this.p.loginLink);
        this.lti = eitherAsyncifyService(this.p.lti);
        this.notification = eitherAsyncifyService(this.p.notification);
        this.oauthProvider = eitherAsyncifyService(this.p.oauthProvider);
        this.oauthToken = eitherAsyncifyService(this.p.oauthToken);
        this.permission = eitherAsyncifyService(this.p.permission);
        this.plagiarism = eitherAsyncifyService(this.p.plagiarism);
        this.role = eitherAsyncifyService(this.p.role);
        this.saml = eitherAsyncifyService(this.p.saml);
        this.section = eitherAsyncifyService(this.p.section);
        this.siteSettings = eitherAsyncifyService(this.p.siteSettings);
        this.snippet = eitherAsyncifyService(this.p.snippet);
        this.ssoProvider = eitherAsyncifyService(this.p.ssoProvider);
        this.submission = eitherAsyncifyService(this.p.submission);
        this.taskResult = eitherAsyncifyService(this.p.taskResult);
        this.tenant = eitherAsyncifyService(this.p.tenant);
        this.transaction = eitherAsyncifyService(this.p.transaction);
        this.user = eitherAsyncifyService(this.p.user);
        this.userSetting = eitherAsyncifyService(this.p.userSetting);
        this.webhook = eitherAsyncifyService(this.p.webhook);
    }
    async rawRequest(opts) {
        return await request(this.config, opts);
    }
}
